/**
 * author : Ryan Liu yanfang.liu@asiainnovations.com
 * date   : 29 Oct 2018
 * desc   : validate.js
 **/

function isEmail(str) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);
}

export default {
    isEmail
};



// WEBPACK FOOTER //
// ./js/global/validate.js